import { useState, useEffect } from 'react';
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS, CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  Filler
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  ChartDataLabels,
  Filler
)

function ChartRSU(props) {
  const { lineData, maxValue, minValue } = props;
  const periodo = (data) => {
    if (data.ano >= minValue && data.ano <= maxValue)
      return data.ano
  }
  const [newLine, setNewLine] = useState([]);
  const [chartType, setChartType] = useState('bar');
  const [negChartType, setNegChartType] = useState('Áreas');
  const [transparence, setTransparence] = useState('ff');

  const [stepSize, setStepSize] = useState(70000);
  const [pointRadius, setPointRadius] = useState(8);
  const [borderWidth, setBorderWidth] = useState(0);
  const [yTitleDisplay, setYTitleDisplay] = useState(true);
  const [xTitleDisplay, setXTitleDisplay] = useState(true);
  const [yTitleSize, setYTitleSize] = useState(28);
  const [xTitleSize, setXTitleSize] = useState(28);
  const [yLabelSize, setYLabelSize] = useState(28);
  const [xLabelSize, setXLabelSize] = useState(28);
  const [mainTitleSize, setMainTitleSize] = useState(38);
  const [legendSize, setLegendSize] = useState(28);
  const [xStepSize, setXStepSize] = useState(1);
  const [yStepSize, setYStepSize] = useState(stepSize);

  const changeType = (status) => {
    if (status === 'bar') {
      setChartType('line');
      setTransparence('9a');
      setNegChartType('Barras');
      setBorderWidth(5);
    }
    if (status === 'line') {
      setChartType('bar');
      setTransparence('ff');
      setNegChartType('Áreas');
      setBorderWidth(0);
    }
  }

  useEffect(() => {
    setNewLine(lineData?.filter(periodo))
  }, [minValue, maxValue]);

  if (newLine?.length === 0 || newLine === null) {
    return (
      <div>
      </div>
    )
  } else {
    newLine.sort(function (a, b) {
      if (a.ano < b.ano)
        return 1;
      if (a.ano > b.ano)
        return -1;
      return 0;
    })
    newLine.sort((a, b) => parseFloat(a.ano) - parseFloat(b.ano));

    var data = {
      labels: newLine?.map((val) => (val.ano).toString()),
      datasets: [
        {
          label: 'Madeiras e derivados',
          type: chartType,
          data: newLine.map((e) => (parseFloat(e.quantidade)) * 0.014),
          backgroundColor: '#00ff00' + transparence,
          borderColor: '#00ff00',
          borderWidth: borderWidth,
          pointStyle: 'circle',
          pointRadius: pointRadius,
          fill: 'origin'
        }, {
          label: 'Têxteis',
          type: chartType,
          data: newLine.map((e) => (parseFloat(e.quantidade)) * 0.056),
          backgroundColor: '#a71eb2' + transparence,
          borderColor: '#a71eb2',
          borderWidth: borderWidth,
          pointStyle: 'circle',
          pointRadius: pointRadius,
          fill: '-1'
        }, {
          label: 'Papéis',
          type: chartType,
          data: newLine.map((e) => (parseFloat(e.quantidade)) * 0.104),
          backgroundColor: '#ff0000' + transparence,
          borderColor: '#ff0000',
          borderWidth: borderWidth,
          pointStyle: 'circle',
          pointRadius: pointRadius,
          fill: '-1'
        },
        {
          label: 'Jardins/Rejeitos',
          type: chartType,
          data: newLine.map((e) => (parseFloat(e.quantidade)) * 0.141),
          backgroundColor: '#0F77BD' + transparence,
          borderColor: '#0F77BD',
          borderWidth: borderWidth,
          pointStyle: 'circle',
          pointRadius: pointRadius,
          fill: '-1'
        },
        {
          label: 'Alimentos',
          type: chartType,
          data: newLine.map((e) => (parseFloat(e.quantidade)) * 0.453),
          backgroundColor: '#bf9000' + transparence,
          borderColor: '#bf9000',
          borderWidth: borderWidth,
          pointStyle: 'circle',
          pointRadius: pointRadius,
          fill: '-1'
        }
      ]
    }

    var options = {
      maintainAspectRatio: false,
      locale: 'pt-br',
      scales: {
        y: {
          stacked: true,
          beginAtZero: false,
          title: {
            display: yTitleDisplay,
            text: 'Quantidade (t)',
            color: '#1E3050',
            font: {
              size: yTitleSize
            }
          },
          grid: {
            color: '#ffffff00',
          },
          ticks: {
            // autoSkip: false,
            color: '#1E3050',
            stepSize: yStepSize,
            font: {
              size: yLabelSize
            }
            // callback: ((value, index, values) => {
            //   return `${value}`
            // })
          },
        },
        x: {
          stacked: true,
          // title: {
          //   display: xTitleDisplay,
          //   text: 'Anos',
          //   color: '#1E3050',
          //   font: {
          //     size: xTitleSize
          //   }
          // },
          grid: {
            color: '#ffffff00',
          },
          ticks: {
            autoSkip: false,
            color: '#1E3050',
            stepSize: xStepSize,
            font: {
              size: xLabelSize
            }
          }
        },
        position: 'left',
      },
      plugins: {
        datalabels: {
          display: false
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            padding: 10,
            color: '#1E3050',
            font: {
              size: legendSize
            }
          },
        },
        title: {
          display: true,
          text: 'Total por ano em tipo',
          color: '#1E3050',
          font: {
            size: mainTitleSize
          }
        },
        subtitle: {
          display: true,
          text: 'Aterro Sanitário - Central de Resíduos do Recreio, Minas do Leão/RS'
        }
      },
    }

    return (
      <div className={'w-[95vw] h-[90vh]'} >
        <Line data={data} options={options} />
      </div>
    )
  }
}

export default ChartRSU;